import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

import '@nimbus-ds/styles/dist/index.css';
import '@nimbus-ds/styles/dist/themes/dark.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './lib/i18n/i18n';

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>,
  document.getElementById('root'),
);
